import { Component, computed, signal, inject } from "@angular/core";
import { PermissionService } from "src/app/modules/core/services/permission.service";
import { DataModeService } from "../../menu/data-mode.service";
import { BasemapService } from "../basemap.service";
import { NgOptimizedImage } from "@angular/common";

@Component({
  selector: "app-basemap-selector",
  templateUrl: "./basemap-selector.component.html",
  styleUrls: ["./basemap-selector.component.scss"],
  imports: [NgOptimizedImage]
})
export class BasemapSelectorComponent {
  permissionService = inject(PermissionService);
  dataModeService = inject(DataModeService);
  private baseMapService = inject(BasemapService);

  baseMap = signal("./assets/basemap/Satellite.png");

  // Map selector (thematic or satellite)
  changeBasemap() {
    this.baseMap.set("./assets/basemap/" + (this.baseMap().includes("OSM") ? "Satellite" : "OSM") + ".png");
    this.baseMapService.isSatelliteImage.set(!this.baseMapService.isSatelliteImage());
  }

  // Get image for preview tile
  imgAltName = computed(() => (this.baseMap().includes("OSM") ? "OSM" : "Satellite"));
}
